export default "__VITE_ASSET__DEcnqKcI__"